/** Hook de sesión de trabajo: expone el usuario logueado, la sucursal activa y los códigos de sucursal, empresa y usuario desde el authStore. */
import { useAuthStore } from "@/stores/authStore";

export const useWorkSession = () => {
  const loggedUserInnerwork = useAuthStore((s) => s.loggedUserInnerwork);
  const activeSucursal = useAuthStore((s) => s.activeSucursal);
  const workspaceResuelto = useAuthStore((s) => s.workspaceResuelto);

  return {
    loggedUserInnerwork,
    activeSucursal,
    workspaceResuelto,
    codSucursal: activeSucursal?.codigo || "",
    codEmpresa: loggedUserInnerwork?.codEmpresa || "",
    codUsuario: loggedUserInnerwork?.codUsuario || "",
  };
};
